import Modal from '@/components/common/AppModal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Icon from './Icon';
import { downloadDataUrl } from '../utils/download';

type ExportPreviewModalProps = {
  show: boolean;
  onHide: () => void;
  previewUrl?: string;
  loading?: boolean;
  filename: string;
  format?: string;
};

export default function ExportPreviewModal({
  show,
  onHide,
  previewUrl,
  loading,
  filename,
  format = 'png'
}: ExportPreviewModalProps) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <Icon name="eye" />
          پیش‌نمایش خروجی {format.toUpperCase()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="d-flex flex-column align-items-center justify-content-center gap-3 text-600 py-5">
            <Spinner animation="border" />
            <span>در حال ساخت پیش‌نمایش...</span>
          </div>
        ) : previewUrl ? (
          <div
            className="border rounded-2 overflow-auto text-center bg-body"
            style={{ maxHeight: '60vh' }}
          >
            <img
              src={previewUrl}
              alt="پیش‌نمایش خروجی"
              className="img-fluid"
            />
          </div>
        ) : (
          <div className="text-muted text-center py-4">
            پیش‌نمایش آماده نیست.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          بستن
        </Button>
        <Button
          variant="success"
          disabled={!previewUrl || loading}
          onClick={() => {
            if (!previewUrl) return;
            downloadDataUrl(previewUrl, filename);
            onHide();
          }}
        >
          <Icon name="download" className="ms-1" />
          دانلود نهایی
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
